import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-destinatarios-auditoria',
  templateUrl: './destinatarios-auditoria.component.html',
  styleUrls: ['./destinatarios-auditoria.component.scss'],
})
export class DestinatariosAuditoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
